import { combineReducers } from 'redux';
import cached from './cached';
import byId from './byId';

export const reducer = combineReducers({
  cached,
  byId
});
